import { render, staticRenderFns } from "./ContactDetaille.vue?vue&type=template&id=3a11b68a"
import script from "./ContactDetaille.vue?vue&type=script&lang=js"
export * from "./ContactDetaille.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports